import { render, staticRenderFns } from "./asset_menu.vue?vue&type=template&id=364f53e1&"
import script from "./asset_menu.vue?vue&type=script&lang=js&"
export * from "./asset_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports